import React from 'react'

export const getPageTitle = (path: string, pathname: string) => {
  const isAvailabilityRules = pathname?.match(/\/availability-rules(?:\/|$)/)

  switch (path) {
    case '':
      return {
        documentTitle: 'Slerp Controls - Insights',
        title: 'Insights',
        tooltipTitle: (
          <span>
            All your insights on this dashboard can be filtered by your store's
            locations and time period.
          </span>
        )
      }
    case 'integrations':
      return {
        documentTitle: 'Slerp Controls - Integration Marketplace',
        title: 'Integration Marketplace',
        tooltipTitle: null
      }
    case 'analytics':
      return {
        documentTitle: 'Slerp Controls - Insights',
        title: 'Insights',
        tooltipTitle: (
          <span>
            All your insights on this dashboard can be filtered by your store's
            locations and time period.
          </span>
        )
      }
    case 'heat-map':
      return {
        documentTitle: 'Slerp Controls - Insights',
        title: 'Insights',
        tooltipTitle: (
          <span>
            All your insights on this dashboard can be filtered by your store's
            locations and time period.
          </span>
        )
      }
    case 'settings':
      return {
        documentTitle: 'Slerp Controls - Settings',
        title: 'Settings',
        tooltipTitle: (
          <span>
            Here's where you can edit the master settings for your brand's Slerp
            account.
          </span>
        )
      }
    case 'orders':
      return {
        documentTitle: 'Slerp Controls - Orders',
        title: 'Orders',
        tooltipTitle: (
          <span>
            A breakdown of all placed and pending orders which can be filtered
            by store, fulfilment type and date range.
          </span>
        )
      }
    case 'location':
      if (isAvailabilityRules) {
        return {
          documentTitle: 'Slerp Controls - Locations - Availability Rules',
          title: 'Availability Rules'
        }
      } else {
        return {
          documentTitle: 'Slerp Controls - Locations',
          title: 'Locations',
          tooltipTitle: (
            <span>
              An{' '}
              <a
                href='https://support.slerp.com/en_gb/stores-and-locations-rkkCUtEpd'
                target='_blank'
                rel='noopener noreferrer'
              >
                overview
              </a>{' '}
              of your
              <br />
              stores' set up.
            </span>
          )
        }
      }
    case 'locations':
      return {
        documentTitle: 'Slerp Controls - Locations',
        title: 'Locations',
        tooltipTitle: (
          <span>
            An{' '}
            <a
              href='https://support.slerp.com/en_gb/stores-and-locations-rkkCUtEpd'
              target='_blank'
              rel='noopener noreferrer'
            >
              overview
            </a>{' '}
            of your
            <br />
            stores' set up.
          </span>
        )
      }
    case 'products':
      return {
        documentTitle: 'Slerp Controls - Products',
        title: 'Products',
        tooltipTitle: (
          <span>
            <a
              href='https://support.slerp.com/en_gb/categories/products-H1ZdJ7G6u'
              target='_blank'
              rel='noopener noreferrer'
            >
              Here's our guides
            </a>{' '}
            for creating and managing your products. See this as your master
            library of producs that you then assign to each of your stores'
            inventories.
          </span>
        )
      }
    case 'modifiers':
      return {
        documentTitle: 'Slerp Controls - Modifiers',
        title: 'Modifiers',
        tooltipTitle: (
          <span>
            Modifiers are a powerful upselling tool. They allow a product to
            have multiple add ons.
            <br />
            <br />
            Find out more{' '}
            <a
              href='https://support.slerp.com/knowledge/modifiers'
              target='_blank'
              rel='noopener noreferrer'
            >
              here
            </a>
            .
          </span>
        )
      }
    case 'discounts':
      return {
        documentTitle: 'Slerp Controls - Discounts',
        title: 'Discounts',
        tooltipTitle: (
          <span>
            <a
              href='https://support.slerp.com/knowledge/creating-and-managing-discount-codes'
              target='_blank'
              rel='noopener noreferrer'
            >
              Discount codes
            </a>{' '}
            can be used to increase conversion, drive loyalty and win back
            customers.
            <br />
            <br />
            Did you know one of the biggest barriers to online sales is delivery
            fees?
            <br />
            <br /> Why not try a free delivery campaign to drive sales on your
            new product?
          </span>
        )
      }
    case 'customers':
      return {
        documentTitle: 'Slerp Controls - Customers',
        title: 'Customers',
        tooltipTitle: (
          <span>
            One of the biggest advantages of selling direct to customers online
            is you have{' '}
            <a
              href='https://support.slerp.com/en_gb/download-customer-database-SyA9W_qt'
              target='_blank'
              rel='noopener noreferrer'
            >
              access to their data
            </a>{' '}
            for your marketing efforts.
            <br />
            <br />
            Here you'll be able to see and download your customers' details and
            order frequencies. Talk to member of our team about CRM
            integrations.
          </span>
        )
      }
    case 'designer':
      return {
        documentTitle: 'Slerp Controls - Designer',
        title: 'Designer',
        tooltipTitle: (
          <span>
            A seamless, branded experience from order button to checkout drives
            trust which in turns drives sales.
            <br />
            <br />
            Designer enables you to fully brand and add character to your Slerp
            storefront.
            <br />
            <br />
            Learn how to optimise your store{' '}
            <a
              href='http://slerp-8156030.hs-sites.com/optimise'
              target='_blank'
              rel='noopener noreferrer'
            >
              here
            </a>
            .
          </span>
        )
      }
    case 'composer':
      return {
        documentTitle: 'Slerp Controls - Composer',
        title: 'Composer',
        tooltipTitle: null
      }
    case 'slerp-menu-manager':
      return {
        documentTitle: 'Slerp Controls - Menu Manager',
        title: 'Menu Manager',
        tooltipTitle: null
      }
    case 'loyalty':
      return {
        documentTitle: 'Slerp Controls - Loyalty',
        title: 'Loyalty',
        tooltipTitle: null
      }
    case 'app-campaigns':
      return {
        documentTitle: 'Slerp Controls - App Campaigns',
        title: 'App Campaigns',
        tooltipTitle: null
      }
    default:
      return {
        documentTitle: 'Slerp Controls',
        title: 'Slerp Controls',
        tooltipTitle: null
      }
  }
}
